// Simple configuration file for ticket/registration products
export const stripeProducts = {
  // Rodeo Event Registration
  eventRegistration: {
    priceId: 'price_1RHbYWIAJBMv6W9IfEy34r2a',
    name: 'Rodeo Event Registration',
    description: 'Entry fee for registering to be part of the Salina Independence Day Rodeo',
    mode: 'payment',
    price: 80.00
  },
  
  // Rodeo Queen
  rodeoQueen: {
    priceId: 'price_1RHbRyIAJBMv6W9IvjY8nhkt',
    name: 'Rodeo Queen',
    description: 'Entrance fee to Rodeo Queen contest - May 24, 2026 9:00 A.M. at Salina Rec Center and Salina Rodeo',
    mode: 'payment',
    price: 80.00
  },
  
  // Child Rodeo Ticket
  childTicket: {
    priceId: 'price_1RHbLKIAJBMv6W9ICLpn2Ipn',
    name: 'Child Rodeo Ticket',
    description: 'Ages 6-11',
    mode: 'payment',
    price: 9.00
  },
  
  // Adult Rodeo Ticket
  adultTicket: {
    priceId: 'price_1RHbKwIAJBMv6W9IWGrUzmqf',
    name: 'Adult Rodeo Ticket',
    description: 'Ages 12 and up',
    mode: 'payment',
    price: 14.00
  }
};

// Helper function to get product by ID
export const getProductByPriceId = (priceId: string) => {
  return Object.values(stripeProducts).find(product => product.priceId === priceId);
};

// Helper function to get product by type
export const getProductByType = (type: string) => {
  switch (type) {
    case 'child':
      return stripeProducts.childTicket;
    case 'general':
      return stripeProducts.adultTicket;
    case 'contestant':
      return stripeProducts.eventRegistration;
    case 'queen':
      return stripeProducts.rodeoQueen;
    default:
      return null;
  }
};